import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Registrazione service worker per PWA (Android install prompt + fallback offline).
// v2 (2026-02): notifica in-app quando è disponibile una nuova versione — l'utente
// può forzare il reload da un banner cliccabile invece di dover chiudere/riaprire
// la PWA manualmente.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        if (!reg) return;
        // Verifica manuale ogni volta che la pagina prende il focus (utile per PWA
        // installate che restano aperte a lungo).
        const check = () => reg.update().catch(() => null);
        window.addEventListener("focus", check);
        // Trigger sull'aggiornamento SW rilevato
        const notify = (worker) => {
          if (!worker) return;
          worker.addEventListener("statechange", () => {
            if (worker.state === "installed" && navigator.serviceWorker.controller) {
              // Nuovo SW pronto: emetti evento globale → banner
              window.dispatchEvent(new CustomEvent("ef-sw-update-available"));
            }
          });
        };
        if (reg.waiting && navigator.serviceWorker.controller) {
          window.dispatchEvent(new CustomEvent("ef-sw-update-available"));
        }
        reg.addEventListener("updatefound", () => notify(reg.installing));
        // Al `controllerchange` (post SKIP_WAITING) → reload della pagina
        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      })
      .catch(() => {
        /* silenzioso: PWA resta utilizzabile anche senza SW */
      });
  });
}
